module.exports = __webpack_public_path__ + "mo/img/address.5da20cfc.png";